import { Media } from 'ca-api-client';
import { mediaFilters } from '@/filters/media';
export default class AddItemsToSet {
    config() {
        return {
            title: 'Add items to this collection',
            description: 'Upload or choose existing items to add to the collection.',
            mode: 'multiple',
            media: true,
            sets: false,
            upload: {
                allow: true,
                newVersion: false,
                allowMultiple: true,
                //allowedFileTypes: ['image', 'document', 'video', 'other'],
                onProcessFile: this.processFile,
                onProcessFiles: this.uploadComplete,
            },
            defaultFilters: [
                { type: 'image,video,document,before_after,audio,other' },
                { interactive_id: null },
                { 360: null },
                { public: null },
            ],
            filterOptions: mediaFilters,
        };
    }
    processFile(file) {
        // no scope here
        return new Promise((resolve) => {
            const serverJson = JSON.parse(file.serverId).data;
            serverJson.url = file.getFileEncodeDataURL();
            const serverData = new Media(serverJson);

            App.$store.dispatch('prependGalleryMediaSelectItem', serverData).then(() => {
                resolve(serverData);
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    uploadComplete() {
        App.$store.commit('setMediaSelectModalCurrentView', 'MediaSelect');
        App.$store.commit('setMediaSelectIsLoading', true);
        App.$store.commit('setMediaSelectLoadingMessage', 'Your upload is processing...');
    }
    doAction() {
        console.log('AddItemsToSet::doAction()');
        const options = App.$store.getters.getMediaSelectOptions;
        const itemTypes = App.$store.getters.getMediaSelectSelectedByType;

        console.log('itemTypes', itemTypes);

        return new Promise((resolve) => {
            App.$store
                .dispatch('updateSet', {
                    id: options.itemId,
                    data: {
                        media: itemTypes.media,
                        children: itemTypes.sets,
                    },
                })
                .then((response) => {
                    resolve(response);
                });
        });
    }
}
